import Styles from "./App.module.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
//importing the main pages
import { Home      } from "./pages/home/home_page";
import { Blogs     } from "./pages/blogs/blogs_page";
import { Shorts    } from "./pages/shorts/shorts_page";
import { Courses   } from "./pages/courses/courses_page";
import { Products  } from "./pages/products/products_page";
import { Projects  } from "./pages/projects/projects_page";
import { Media     } from "./pages/media/media_page";
import { AboutUs   } from "./pages/about_us/about_page";
import { ContactUs } from "./pages/contact_us/contact_page";
import { Gemini    } from "./pages/gemini/gemini_page";
//importing the sub pages
import { ViewBlog    } from "./pages/view_blog/view_blog_page";
import { ViewCourse  } from "./pages/view_course/view_course_page";
import { ViewProject } from "./pages/view_project/view_project_page";
import { ViewProduct } from "./pages/view_product/view_product_page";
import { ViewList    } from "./pages/view_list/view_list_page";
import { VideoPlayer } from "./pages/video_player/video_player_page";
//wrong routs
import { NotFound } from "./main_components/error_message";
const App = () => {
  const { App } = Styles;
  return (
    <main className={ App }>
      <Router>
        <Routes>
          {/* routing to the main pages */}
          <Route path="/home"       element={ <Home      loadingDuration = { 2000 }/> }/>
          <Route path="/blogs"      element={ <Blogs     loadingDuration = { 2000 }/> }/>
          <Route path="/shorts"     element={ <Shorts    loadingDuration = { 2000 }/> }/>
          <Route path="/courses"    element={ <Courses   loadingDuration = { 2000 }/> }/>
          <Route path="/products"   element={ <Products  loadingDuration = { 2000 }/> }/>
          <Route path="/projects"   element={ <Projects  loadingDuration = { 2000 }/> }/>
          <Route path="/media"      element={ <Media     loadingDuration = { 2000 }/> }/>
          <Route path="/about_us"   element={ <AboutUs   loadingDuration = { 2000 }/> }/>
          <Route path="/contact_us" element={ <ContactUs loadingDuration = { 2000 }/> }/>
          <Route path="/gemini"     element={ <Gemini    loadingDuration = { 2000 }/> }/>
          {/* routing to the sub pages */}
          <Route path="/blogs/view_blog"       element={ <ViewBlog    loadingDuration = { 2000 }/> }/>
          <Route path="/courses/view_course"   element={ <ViewCourse  loadingDuration = { 2000 }/> }/>
          <Route path="/products/view_product" element={ <ViewProduct loadingDuration = { 2000 }/> }/>
          <Route path="/projects/view_project" element={ <ViewProject loadingDuration = { 2000 }/> }/>
          <Route path="/view_list"             element={ <ViewList    loadingDuration = { 2000 }/> }/>
          <Route path="/video_player"          element={ <VideoPlayer loadingDuration = { 2000 }/> }/>
          {/* wrong routes */}
          <Route path="/" element={ <Navigate to="/home" replace /> } />
          <Route path="*" element={ <NotFound/> }/>
        </Routes>
      </Router>
    </main>
  );
};
export default App;
